import { For, Show } from "solid-js"
import { useI18n } from "@opencode-ai/ui/context/i18n"

export const openEvidenceEvent = "datox:open-evidence"

export type EvidenceLocator = {
  quote?: string | null
  page?: number | null
  sheet?: string | null
  cell_range?: string | null
  row?: number | null
}

export type EvidenceReference = {
  sessionID?: string
  projectID?: string
  fileID: string
  fileName?: string | null
  extractedTable?: string | null
  evidence?: EvidenceLocator[]
}

type SourceExplanation = {
  type: "dashboard_source_explanation"
  sources: Array<{
    source_file_id?: string | null
    source_file_name?: string | null
    source_extracted_table?: string | null
    evidence?: EvidenceLocator[]
  }>
}

const block = /```json\s*([\s\S]*?"type"\s*:\s*"dashboard_source_explanation"[\s\S]*?)```/g

export function explanationFromText(text: string) {
  const matches = [...text.matchAll(block)]
  const raw = matches.at(-1)?.[1]
  if (!raw) return
  try {
    const value = JSON.parse(raw) as SourceExplanation
    if (value.type !== "dashboard_source_explanation" || !Array.isArray(value.sources)) return
    return value
  } catch {
    return
  }
}

export function explanationMarkdown(text: string) {
  return explanationFromText(text) ? text.replace(block, "").trim() : text
}

export function openEvidence(reference: EvidenceReference) {
  window.dispatchEvent(new CustomEvent(openEvidenceEvent, { detail: reference }))
}

export function EvidenceSourceCards(props: { text: string; sessionID?: string }) {
  const i18n = useI18n()
  const value = () => explanationFromText(props.text)
  return (
    <Show when={value()}>
      {(explanation) => (
        <div class="mt-3 flex flex-col gap-2">
          <For each={explanation().sources.filter((source) => !!source.source_file_id)}>
            {(source) => (
              <div class="flex items-center justify-between gap-3 rounded-md border border-border-weak-base bg-background-base px-3 py-2">
                <div class="min-w-0">
                  <div class="truncate text-13-medium text-text-base">{source.source_file_name || source.source_extracted_table || i18n.t("ui.sessionReview.openFile")}</div>
                  <Show when={source.source_file_name && source.source_extracted_table}>
                    <div class="truncate text-12-regular text-text-weak">{source.source_extracted_table}</div>
                  </Show>
                </div>
                <button
                  type="button"
                  class="shrink-0 rounded-md border border-border-base px-2 py-1 text-12-medium text-text-base hover:bg-background-weak-base"
                  onClick={() => openEvidence({
                    sessionID: props.sessionID,
                    fileID: source.source_file_id!,
                    fileName: source.source_file_name,
                    extractedTable: source.source_extracted_table,
                    evidence: source.evidence,
                  })}
                >
                  {i18n.t("ui.sessionReview.openFile")}
                </button>
              </div>
            )}
          </For>
        </div>
      )}
    </Show>
  )
}
